import React from 'react';
import {
  MDBCol,
  MDBRow,
  MDBInput,
  MDBModal,
  MDBNavLink,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBDataTable,
  MDBListGroup, MDBListGroupItem,
  MDBContainer, MDBInputGroup,
  MDBBtn
} from 'mdbreact';
import './expenses-view.css';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DateFilter from '../../components/DateFilter';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import { Pie } from "react-chartjs-2";
import moment from 'moment';
import Expense from '../../components/expense';
import Breadcrumb from '../../components/breadcrumb';
import { format } from '../../helpers/invoiceNumber';

class HomeView extends React.Component {

  state = {
    modal: false,
    pdfModal: false,
    newExpense: {},
    newLineItem: {},
    rankType: 'all',
    showAdd: false
  }

  handleChange = (value, prop) => {
    var t = this.state.newExpense;
    t[prop] = value;
    this.setState({
      newExpense: t
    });
  }

  handleLineChange = (value, prop) => {
    var t = this.state.newLineItem;
    t[prop] = value;
    this.setState({
      newLineItem: t
    });
  }

  togglePDF = () => {
    this.setState({
      pdfModal: !this.state.pdfModal,
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      newExpense: {},
    });
  }

  addLineItem = () => {
    this.setState({
      newExpense: {
        ...this.state.newExpense,
        descriptions: this.state.newExpense.descriptions ? [...this.state.newExpense.descriptions, { ...this.state.newLineItem }] : [{ ...this.state.newLineItem }]
      }
    });
  }

  deleteLineItem = (desc) => {
    this.setState({
      newExpense: {
        ...this.state.newExpense,
        descriptions: this.state.newExpense.descriptions.filter(item => item.description != desc)
      }
    });
  }

  edit = (expense) => {
    this.setState({
      modal: !this.state.modal,
      newExpense: expense
    });
  }

  componentDidMount() {
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetExpenses();
    }
  }

  componentDidUpdate(prevProps) {
    // Reload expenses when selectedCompanyId becomes available or changes
    if (this.props.selectedCompanyId && this.props.selectedCompanyId !== prevProps.selectedCompanyId) {
      this.props.dispatchGetExpenses();
    }
  }

  createExpense = () => {
    this.props.createExpense(this.state.newExpense);
    this.setState({
      modal: !this.state.modal,
      newExpense: ''
    });
  }

  setRank = (rank) => {
    this.setState({
      rankType: rank
    });
  }

  scrollToTop = () => window.scrollTo(0, 0);

  getDataFromURL = (url, user) => new Promise((resolve, reject) => {
    setTimeout(() => {
      let req = {
        headers: {
          username: user.username,
          token: user.token,
          AUTHORIZATION: user.token
        },
        method: 'GET'
      }

      fetch(url, req)
        .then(response => response.blob())
        .then(data => {
          resolve(data)
        });
    });
  }, 2000);

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd })
  }

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    let all = 0;
    let paid = 0;
    let un = 0;
    let quote = 0;
    let unTotal = 0;
    let paidTotal = 0;
    let quoteTotal = 0;

    var Expenses = [];


    let methodPaids = {};

    if (this.props.expenses.expenses.length > 0) {
      console.log(this.props.expenses.expenses)
      Expenses = this.props.expenses.expenses.map(p => {

        if (!methodPaids[p.methodPaid]) methodPaids[p.methodPaid] = 0;

        let total = parseFloat((p.price + '').replace(',', '.'));

        all += 1;
        if (p.paid != 'true') {
          un += 1;
          unTotal += total;
        }
        else {
          paid += 1;
          paidTotal += total;
        }

        return {
          _id: p._id,
          name: p.client ? (p.client.name + ' ' + (p.client.surname ? p.client.surname : '')) : p.to,
          expenseDate: moment(p.expenseDate).format('YYYY-MM-DD'),
          diff: !p.paid ? (moment().diff(moment(p.dueDate), "days")) > 0 ?

            (<span className="right badge badge-danger">{moment().diff(moment(p.dueDate), "days")}{' days overdue'}</span>) :
            (<span className="right badge badge-warning">{moment().diff(moment(p.dueDate), "days")}{' days left'}</span>)
            : '',
          dueDate: !!p.dueDate ? moment(p.dueDate).format('YYYY-MM-DD') : '',
          expenseNumber: p.expenseNumber,
          expenseNumberDisplay: (<span>{!!p.isQuote && <span className="right badge badge-warning">quote</span>}{!!p.paid && !p.isQuote && <span className="right badge badge-success">paid</span>}{!p.paid && !p.isQuote && <span className="right badge badge-danger">un-paid</span>}{' '}{p.expenseNumber}</span>),
          paid: p.paid,
          total: 'R ' + format(total),
          totalA: total,
          isQuote: p.isQuote,
          method: p.methodPaid,
          view: <MDBContainer>
            <button type='button' className='btn btn-sm btn-info' onClick={() => {
              this.props.getExpense(p._id, loaded);
              this.props.selectExpense(p._id);
              let updateshowAdd = this.updateshowAdd;
              function loaded(error) {
                if (!error) updateshowAdd(true);
              }
            }}>
              View
            </button></MDBContainer>,
        }
      });
    }

    var dataPie = {
      labels: Object.keys(methodPaids),
      datasets: [
        {
          data: Object.keys(methodPaids).map(i => methodPaids[i]),
          backgroundColor: [
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD"
          ],
          hoverBackgroundColor: [
            "#FF5A5E",
            "#5AD3D1",
            "#FFC870",
            "#A8B3C5",
            "#616774",
            "#DA92DB"
          ]
        }
      ]
    };

    const data = {
      columns: [
        {
          label: 'Expense Date',
          field: 'expenseDate',
          sort: 'asc'
        },
        {
          label: 'Status',
          field: 'expenseNumberDisplay',
          sort: 'asc'
        },
        {
          label: 'Amount',
          field: 'total',
          sort: 'asc'
        },
        {
          label: 'Client',
          field: 'name',
          sort: 'asc'
        },
        {
          label: '',
          field: 'view',
          sort: 'asc'
        }
      ],
      rows: Expenses.filter(i => {
        if (this.state.rankType == 'all') return true;
        else if (this.state.rankType == 'paid') return !!i.paid;
        else if (this.state.rankType == 'unpaid') return !!!i.paid;
      }).sort(function (a, b) {
        if (a.expenseDate < b.expenseDate) return 1; else return -1;
      })
    };

    return (
      <div className="content-wrapper p-2">

        <SpinnerView showSpinner={this.props.expenses.loading} />

        {/* Page Header */}
        {!this.state.showAdd && (
          <div className="page-header">
            <h1 className="page-title">
              <i className="fas fa-receipt"></i>
              Expenses
            </h1>
          </div>
        )}

        {!this.state.showAdd && <DateFilter action={this.props.dispatchGetExpenses} />}

        {this.state.showAdd && <Expense updateshowAdd={this.updateshowAdd}/>}

        {!this.state.showAdd && (
          <div className="expense-toolbar expense-actions-desktop">
            {/* New Button */}
            <button
              className="expense-toolbar-btn primary"
              onClick={() => {
                this.props.dispatchClearExpense();
                this.updateshowAdd(true);
              }}
            >
              <i className="fas fa-plus"></i>
              New Expense
            </button>

            {/* Recurring Link */}
            <Link className="expense-toolbar-btn secondary" to="/recurring?type=expenses">
              <i className="fas fa-sync-alt"></i>
              Recurring
            </Link>

            <div className="expense-toolbar-divider"></div>

            {/* Filter Buttons */}
            <div className="expense-toolbar-group">
              <button
                className={`expense-toolbar-btn filter ${this.state.rankType === 'all' ? 'active' : ''}`}
                onClick={() => this.setRank('all')}
              >
                All
                <span className="toolbar-badge">{all}</span>
              </button>
              <button
                className={`expense-toolbar-btn filter ${this.state.rankType === 'paid' ? 'active' : ''}`}
                onClick={() => this.setRank('paid')}
              >
                Paid
                <span className="toolbar-badge">{paid}</span>
              </button>
              <button
                className={`expense-toolbar-btn filter ${this.state.rankType === 'unpaid' ? 'active' : ''}`}
                onClick={() => this.setRank('unpaid')}
              >
                Unpaid
                <span className="toolbar-badge">{un}</span>
              </button>
            </div>

            <div className="expense-toolbar-divider"></div>

            {/* Export Button */}
            <DownloadLink
              label={<><i className="fas fa-file-export"></i> Export CSV</>}
              className="expense-toolbar-btn export"
              style={{ textDecoration: 'none' }}
              filename={"sage_import.csv"}
              exportFile={() => {
                if (this.props.global) {
                  let url = urls.getExpenses(this.props.selectedCompanyId) + '/export';
                  url = url + '?from=' + this.props.global.dateFrom.format('YYYY-MM-DD');
                  url = url + '&to=' + this.props.global.dateTo.format('YYYY-MM-DD');
                  url = url + '&type=' + this.props.global.dateIndex;
                  return Promise.resolve(this.getDataFromURL(url, this.props.authUser))
                }
              }}
            />
          </div>
        )}

        {/* Unified Content Card */}
        {!this.state.showAdd && (
          <div className="expense-content-card expense-actions-desktop">
            {/* Stats Row */}
            <div className="expense-stats-row">
              <div className="expense-stat-item paid">
                <div className="expense-stat-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="expense-stat-content">
                  <span className="expense-stat-label">Paid</span>
                  <span className="expense-stat-value">R {format(paidTotal)}</span>
                </div>
              </div>
              <div className="expense-stat-item outstanding">
                <div className="expense-stat-icon">
                  <i className="fas fa-exclamation-circle"></i>
                </div>
                <div className="expense-stat-content">
                  <span className="expense-stat-label">Outstanding</span>
                  <span className="expense-stat-value">R {format(unTotal)}</span>
                </div>
              </div>
            </div>

            {/* Desktop Table View */}
            <div className="expense-table-desktop">
              <MDBDataTable
                disableRetreatAfterSorting={true}
                striped
                bordered
                small
                data={data}
              />
            </div>
          </div>
        )}

        {
          !this.state.showAdd && this.state.rankType == 'paid' && <div className="card card-danger smallpie" style={{marginTop: 16}}>
            <div className="card-header">
              <h3 className="card-title">Payment Methods</h3>

              <div className="card-tools">
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                  <i className="fas fa-minus"></i>
                </button>
                <button type="button" className="btn btn-tool" data-card-widget="remove">
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="chartjs-size-monitor"><div className="chartjs-size-monitor-expand"><div className=""></div></div><div className="chartjs-size-monitor-shrink"><div className=""></div></div></div>
              <Pie data={dataPie} className={'pieChart'} options={{ responsive: true }} />
            </div>
          </div>
        }

        {/* Mobile Card View */}
        {!this.state.showAdd && (
          <div className="expense-cards-mobile">
            {/* Mobile Filter Pills */}
            <div className="expense-filter-pills">
              <button
                className={`expense-filter-pill ${this.state.rankType === 'all' ? 'active' : ''}`}
                onClick={() => this.setRank('all')}
              >
                All<span className="badge-count">{all}</span>
              </button>
              <button
                className={`expense-filter-pill ${this.state.rankType === 'paid' ? 'active' : ''}`}
                onClick={() => this.setRank('paid')}
              >
                Paid<span className="badge-count">{paid}</span>
              </button>
              <button
                className={`expense-filter-pill ${this.state.rankType === 'unpaid' ? 'active' : ''}`}
                onClick={() => this.setRank('unpaid')}
              >
                Unpaid<span className="badge-count">{un}</span>
              </button>
            </div>

            {/* Mobile Summary Cards */}
            <div className="expense-summary-container">
              <div className="expense-summary-card paid">
                <div className="expense-summary-label">Paid</div>
                <div className="expense-summary-value">R {format(paidTotal)}</div>
              </div>
              <div className="expense-summary-card outstanding">
                <div className="expense-summary-label">Outstanding</div>
                <div className="expense-summary-value">R {format(unTotal)}</div>
              </div>
            </div>

            {/* Mobile Action Buttons */}
            <div className="expense-actions-mobile">
              <button
                className="expense-action-btn danger"
                onClick={() => {
                  this.props.dispatchClearExpense();
                  this.updateshowAdd(true);
                }}
              >
                <i className="fas fa-plus"></i> New Expense
              </button>
              <Link className="expense-action-btn" to="/recurring?type=expenses">
                <i className="fa fa-retweet"></i> Recurring
              </Link>
            </div>

            {/* Expense Cards List */}
            {Expenses.filter(i => {
              if (this.state.rankType === 'all') return true;
              else if (this.state.rankType === 'paid') return !!i.paid;
              else if (this.state.rankType === 'unpaid') return !i.paid;
              return true;
            }).sort((a, b) => {
              if (a.expenseDate < b.expenseDate) return 1;
              return -1;
            }).map((expense, index) => (
              <div
                key={expense._id || index}
                className={`expense-card ${!expense.paid ? 'unpaid' : ''}`}
                onClick={() => {
                  this.props.getExpense(expense._id, (error) => {
                    if (!error) this.updateshowAdd(true);
                  });
                  this.props.selectExpense(expense._id);
                }}
                style={{ cursor: 'pointer' }}
              >
                <div className="expense-card-header">
                  <span className="expense-card-number">{expense.expenseNumber}</span>
                  <span className={`expense-card-status ${expense.paid ? 'paid' : 'unpaid'}`}>
                    {expense.paid ? 'Paid' : 'Unpaid'}
                  </span>
                </div>
                <div className="expense-card-client">{expense.name}</div>
                <div className="expense-card-details">
                  <div className="expense-card-date">
                    <span className="expense-card-date-label">Due Date</span>
                    {expense.dueDate || expense.expenseDate}
                  </div>
                  <div className="expense-card-amount">
                    <span className="expense-card-amount-label">Amount</span>
                    {expense.total}
                  </div>
                </div>
                {expense.diff && <div className="expense-card-overdue">{expense.diff}</div>}
              </div>
            ))}
          </div>
        )}


      </div >
    );
  }
}
export default HomeView;
